import { ChangeDetectionStrategy, Component, effect, Signal } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonV3Component } from '@gea/digital-ui-lib';
import { AssetTableRow } from '../data-maintenance.model';

export interface DeleteAssetDialogData {
  asset: AssetTableRow;
  categoryId: string;
  isDeleting: Signal<boolean>;
  onConfirmDelete: () => void;
}

@Component({
  selector: 'app-delete-asset-dialog',
  standalone: true,
  imports: [ButtonV3Component],
  templateUrl: './delete-asset-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteAssetDialogComponent {
  asset: AssetTableRow;
  categoryId: string;
  isDeleting: Signal<boolean>;
  private readonly onConfirmDelete: () => void;

  constructor(
    private readonly dialogRef: DynamicDialogRef,
    private readonly dialogConfig: DynamicDialogConfig<DeleteAssetDialogData>
  ) {
    const data = this.dialogConfig.data!;
    this.asset = data.asset;
    this.categoryId = data.categoryId;
    this.isDeleting = data.isDeleting;
    this.onConfirmDelete = data.onConfirmDelete;

    effect(() => {
      this.dialogConfig.dismissableMask = !this.isDeleting();
    });
  }

  confirm(): void {
    if (this.isDeleting()) return;
    this.onConfirmDelete();
  }

  cancel(): void {
    if (this.isDeleting()) return;
    this.dialogRef.close();
  }
}
